import React, { } from 'react';
import { connect } from 'react-redux'
import { sendAccountCertificate, seeStateCertificate, getUserInfo } from '../../actions/userActions'
import ValidateAccount from '../../containers/Navbar/VerifyAccount/VerifyAccount';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTokenCallback } from '../../utils/hooks/useTokenCallback';
import localStorage from '../../utils/hooks/useLocalStorage';

const CertificateAccountData = ({ sendAccountCertificate, isLoadingGetUserInfo, userInfo, getUserInfo, seeStateCertificate, history }) => {
    let schema = yup.object().shape({
        identificationFile: yup.mixed().test("fileSize", "Requerido", (value) => {


            if (value && value.type) {
                return value.type.includes('pdf')
            } else {
                return false;
            }



        }),
        identificationType: yup.string().required(""),
        identificationNumber: yup.string().required("requerido"),
        currentLocation: yup.string().required("requerido"),
        currentAddress: yup.string().required("requerido"),
        currentDepartment: yup.string().required("requerido"),
        currentCity: yup.string().required("requerido"),
        currentCountry: yup.string().required("requerido"),


    });
    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: schema,
        initialValues: {
            identificationType: "CC",
            identificationNumber: "",
            identification: "",
            currentLocation: "",
            currentAddress: "",
            currentDepartment: "",
            currentCity: "",
            currentCountry: "Colombia",
        },
        onSubmit: values => {
            const formData = new FormData();

            for (var key in values) {
                formData.append(key, values[key]);
            }
            sendAccountCertificate(formData, history)
        },
    });

    useTokenCallback(() => {
        getUserInfo(localStorage().getItem('idUser'))
    }, [])




    return (
        <ValidateAccount
            formik={formik}
        />
    )


}
const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo.userInfo,
        isLoadingGetUserInfo: state.userInfo.isLoadingGetUserInfo
    }
}

export default connect(mapStateToProps, { sendAccountCertificate, getUserInfo, seeStateCertificate })(CertificateAccountData)
